import { render } from "./ks-bank-view.vue?vue&type=template&id=3d892c76"
import script from "./ks-bank-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ks-bank-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/ks-bank-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d892c76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d892c76', __exports__)) {
    api.reload('3d892c76', __exports__)
  }
  
  module.hot.accept("./ks-bank-view.vue?vue&type=template&id=3d892c76", () => {
    api.rerender('3d892c76', render)
  })

}


export default __exports__